__turbopack_context__.v({
  "expandedContent": "expandedContent-module-scss-module__rLl_4W__expandedContent",
  "fadeInSlide": "expandedContent-module-scss-module__rLl_4W__fadeInSlide",
  "linkItem": "expandedContent-module-scss-module__rLl_4W__linkItem",
  "panelButtonsSection": "expandedContent-module-scss-module__rLl_4W__panelButtonsSection",
});
